import React, { useEffect } from 'react';
import 'config/styles/main.scss';
import firebase from 'firebase/app'
import 'firebase/analytics'
import { Container } from 'react-bootstrap'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import 'bootstrap/dist/css/bootstrap.min.css'
import config from 'config/env';
import AppNavbar from 'shared/components/AppNavbar';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import Routes from 'routes';

library.add(fas);

function App() {
  const userPrefs = useSelector((state: RootState) => state.user.preferences);

  useEffect(() => {
    if (process.env.REACT_APP_BUILD_TARGET === 'production') {
      if (!firebase.apps.length) {
        let firebaseConfig = config.firebaseConfig;
        let firebaseApp = firebase.initializeApp(firebaseConfig);
        firebase.analytics(firebaseApp);
      }
    } else {
      console.log(process.env.REACT_APP_BUILD_TARGET);
    }
  }, []);

  useEffect(() => document.body.classList.add(`app-bg--${userPrefs.theme}`), [userPrefs.theme]);

  return (
    <>
      <AppNavbar />
      <Container className="mt-2">
        <Routes />
      </Container>
    </>
  );
}

export default App;
